import { ELECTRON_APP_PROTOCOL, WebPaths } from '@griply/types';
import { QueryParamOptions } from 'shared/lib/react-router-dom';

// Consumed straight off the deep link and never carried onward, so it is not a globally allowed parameter.
export const DESKTOP_CODE_PARAM = 'desktopCode';

export const getDesktopSignInBrowserUrl = (
  challenge: string,
  path: WebPaths = WebPaths.Login,
): string => {
  const params = new URLSearchParams({
    [QueryParamOptions.DesktopChallenge]: challenge,
  });

  return `${window.location.origin}${path}?${params.toString()}`;
};

// The challenge rides along so the shell can spot a stale hand-off before spending the code on it.
export const getDesktopSignInCallbackUrl = (
  code: string,
  challenge: string,
): string => {
  const params = new URLSearchParams({
    [DESKTOP_CODE_PARAM]: code,
    [QueryParamOptions.DesktopChallenge]: challenge,
  });

  return `${ELECTRON_APP_PROTOCOL}://login?${params.toString()}`;
};
